import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="notfound-hero">
        <div className="container">
          <div className="notfound-content">
            <div className="error-code">404</div>
            <h1>Page Not Found</h1>
            <div className="error-divider"></div>
            <p className="error-message">
              The page you are looking for might have been moved, deleted, or is temporarily unavailable.
            </p>
            <p className="error-suggestion">
              Please check the URL or return to our homepage to continue exploring AALI GROUP.
            </p>
            <Link to="/" className="btn-primary notfound-btn">
              <i className="fas fa-home"></i> Go to Home
            </Link>
          </div>
        </div>
      </div>

      {/* Optional illustration section – keeps the design balanced */}
      <div className="notfound-illustration">
        <div className="container">
          <div className="illustration-grid">
            <div className="illustration-item">
              <i className="fas fa-compass"></i>
              <h3>Lost your way?</h3>
              <p>Our navigation is always improving – try using the menu above.</p>
            </div>
            <div className="illustration-item">
              <i className="fas fa-tools"></i>
              <h3>Technical glitch?</h3>
              <p>If you believe this is an error, please <Link to="/contact">contact support</Link>.</p>
            </div>
            <div className="illustration-item">
              <i className="fas fa-rocket"></i>
              <h3>Explore our world</h3>
              <p>Visit our <Link to="/businesses">Businesses</Link> or <Link to="/about">About</Link> page.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;